import { message as antdMessage, type MessageArgsProps } from 'antd'
import { type ReactNode } from 'react'

export function loadingMessage(content: string, args?: MessageArgsProps) {
  antdMessage.loading({ ...args, content })
}

export function infoMessage(content: string, args?: MessageArgsProps) {
  antdMessage.info({ ...args, content })
}

export function successMessage(content: ReactNode, args?: MessageArgsProps) {
  antdMessage.success({ ...args, content })
}

export function warningMessage(content: string, args?: MessageArgsProps) {
  antdMessage.warning({ ...args, content })
}

export function errorMessage(content: string, args?: MessageArgsProps) {
  antdMessage.error({ ...args, content })
}
